import { defaults } from './env-defaults';
import { PortalAppEnvironment } from '@nuso/portal/environments';

export const environment: PortalAppEnvironment = {
  ...defaults,
  envName: 'staging',
  sentry: 'https://bc94c0cb008a479985dd3fcfc9233873@sentry.io/1192572',
  liveTeamworkSupportEnabled: false,
  customerTestingEnabled: true,
  salesforceSupportEnabled: true,
};
